export function getUsersPreferredLanguage() {
  return window.navigator.language;
}